// extracted by mini-css-extract-plugin
module.exports = {"title":"Bid_title__2vROC","info":"Bid_info__12iBZ","stage":"Bid_stage__3ZwMI","row":"Bid_row__2uQ9Y","col":"Bid_col__2la1Y","btns":"Bid_btns__XuRez","button":"Bid_button__331H8"};